import {
  AuthContextProps,
  FeeData,
  FormHookDispState,
} from "../../shared/data/types";

interface FetchProps {
  sendRequest: (
    url: string,
    method?: string,
    body?: BodyInit,
    headers?: HeadersInit,
    successMessage?: boolean,
    zeroResultsKey?: string
  ) => Promise<any>;
}

interface GetUserFeesProps extends FetchProps {
  setLoadedFees: React.Dispatch<React.SetStateAction<FeeData[]>>;
  uid: string;
}

export const getUserFees = async (props: GetUserFeesProps) => {
  const { sendRequest, setLoadedFees, uid } = props;

  try {
    const apiUrl = `${process.env.REACT_APP_BACKEND_URL}/fees/${uid}`;
    const responseData: { fees: FeeData[] } = await sendRequest(
      apiUrl,
      "GET",
      null,
      {}
    );

    setLoadedFees(responseData.fees);
  } catch (err) {}
};

interface EditFeeProps extends FetchProps {
  auth: AuthContextProps;
  setLoadedFees: React.Dispatch<React.SetStateAction<FeeData[]>>;
  feeId: string;
  formState: FormHookDispState;
}

export const editFee = async (props: EditFeeProps) => {
  const { sendRequest, setLoadedFees, feeId, auth, formState } = props;

  try {
    const apiUrl = `${process.env.REACT_APP_BACKEND_URL}/fees/single/${feeId}`;
    const responseData: { fee: FeeData } = await sendRequest(
      apiUrl,
      "PUT",
      JSON.stringify({
        icms: +formState?.inputs?.icms?.value / 100 || 0,
        pis: +formState?.inputs?.pis?.value / 100 || 0,
        cofins: +formState?.inputs?.cofins?.value / 100 || 0,
        b1Tariff: +formState?.inputs?.b1Tariff?.value || 0,
        a4tusdG: +formState?.inputs?.a4tusdG?.value || 0,
        a4GreenDemand: +formState?.inputs?.a4GreenDemand?.value || 0,
        a4GreenNonPeakTusd: +formState?.inputs?.a4GreenNonPeakTusd?.value || 0,
        a4GreenNonPeakTe: +formState?.inputs?.a4GreenNonPeakTe?.value || 0,
        a4GreenPeakTusd: +formState?.inputs?.a4GreenPeakTusd?.value || 0,
        a4GreenPeakTe: +formState?.inputs?.a4GreenPeakTe?.value || 0,
        a4BlueNonPeakDemand:
          +formState?.inputs?.a4BlueNonPeakDemand?.value || 0,
        a4BlueNonPeakTusd: +formState?.inputs?.a4BlueNonPeakTusd?.value || 0,
        a4BlueNonPeakTe: +formState?.inputs?.a4BlueNonPeakTe?.value || 0,
        a4BluePeakDemand: +formState?.inputs?.a4BluePeakDemand?.value || 0,
        a4BluePeakTusd: +formState?.inputs?.a4BluePeakTusd?.value || 0,
        a4BluePeakTe: +formState?.inputs?.a4BluePeakTe?.value || 0,
      }),
      {
        Authorization: "Bearer " + auth.token,
        "Content-Type": "application/json",
      }
    );

    setLoadedFees((prevValues) => {
      return prevValues.map((fee) => {
        if (fee._id === responseData.fee?._id) {
          fee = responseData.fee;
        }
        return fee;
      });
    });
  } catch (err) {}
};
